module.exports = __webpack_public_path__ + "img/truckHead-yellow.4e69a5d1.svg";